import React, { useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';

import { setClassNameInDefns } from '../../common/definitionHelper';
import { getFormattedTime } from '../../common/dateHelper';
import { USER_TYPE_EMP, USER_TYPE_JS, USER_TYPE_MEMBER1, USER_TYPE_MEMBER2 } from '../../common/constants';

import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdAvatar from '../../common/elemental/AfitdAvatar';

import MessageFileBlock from '../../dashboardMyMessages/subComponents/MessageFileBlock';

import cx from 'clsx';
import _isNil from 'lodash/isNil';
import _trim from 'lodash/trim';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _defaultTo from 'lodash/defaultTo';

const styles = theme => ({
    root: {
        display: 'flex',

        padding: '0 0 23px 0',
    },
    rootJs: {
        justifyContent: 'flex-start',
    },
    rootEmp: {
        justifyContent: 'flex-end',
    },
    chatRightBlock2ProfileImageContainer: {
        marginRight: '12px',
    },
    chatRightBlock2MessageContainer: {
        width: '64%',
    },
    imageContainer: {
        position: 'relative',
    },
    profileImage: {
        width: 47,
        height: 47,
        // clipPath: 'circle(50% at center)',
        // '-webkit-clip-path': 'circle(50% at center)',
    },
    smallCompanyLogo: {
        border: '1px solid #D5D7DD',
        width: 25,
        height: 25,
        fontSize: '14px',
    },
    attachmentContainer: {
        marginTop: '6px',
    },
    contentContainerIn: {
        padding: '12px',
        borderRadius: '10px',
        wordWrap: 'break-word',
    },
    contentContainerJs: {
        background: '#E1F7F8',
        border: '1px solid #1D8A8B',
    },
    contentContainerMember1: {
        background: '#E1F7F8',
        border: '1px solid #1D8A8B',
    },
    contentContainerMember2: {
        background: '#fff3ea',
        border: '1px solid #FC821F',
    },
    contentContainerEmp: {
        background: '#F0F2F6',
        border: '1px solid #F0F2F6',
    },
    messageAgeText: {
        marginLeft: '10px',
        fontSize: '13px',
    },
    hidden: {
        display: 'none',
    },
});

const getDefns = params => {
    const { props } = params;
    const { classes, createDt, content, senderProfileImageUrl, attachment, type, companyImage, isInternal } = props;
    const {
        contentContainerIn: contentContainerInCls,
        contentContainerJs: contentContainerJsCls,
        contentContainerMember1: contentContainerMember1Cls,
        contentContainerMember2: contentContainerMember2Cls,
        contentContainerEmp: contentContainerEmpCls,
        attachmentContainer: attachmentContainerCls,
        hidden: hiddenCls,
        root: rootCls,
        rootJs: rootJsCls,
        rootEmp: rootEmpCls,
    } = classes;

    let createDtText = '';
    if (createDt) {
        createDtText = getFormattedTime(createDt);
    }
    const isEmptyContent = _isNil(content) || _trim(content) === '';
    const isJobSeeker = type === USER_TYPE_JS;
    // const isMember1 = type === USER_TYPE_MEMBER1;
    // const isMember2 = type === USER_TYPE_MEMBER2;

    const defns = {
        root: {
            className: cx(rootCls, { [rootJsCls]: type === USER_TYPE_JS , [rootEmpCls]: type === USER_TYPE_EMP }),
        },
        contentContainerIn: {
            className: cx(contentContainerInCls, {
                [hiddenCls]: attachment && isEmptyContent,
                [contentContainerMember1Cls]: type === USER_TYPE_MEMBER1,
                [contentContainerMember2Cls]: type === USER_TYPE_MEMBER2,
                [contentContainerJsCls]: type === USER_TYPE_JS,
                [contentContainerEmpCls]: type === USER_TYPE_EMP,
            }),
        },
        attachmentContainer: {
            className: cx(attachmentContainerCls, { [hiddenCls]: !attachment }),
        },

        attachment: {
            attachment,
        },
        profileImage: {
            src: senderProfileImageUrl,
            alt: isJobSeeker ? 'job seeker profile picture' : 'company logo',
        },
        smallCompanyLogoBadge: {
            overlap: 'circle',
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            },
            invisible: isJobSeeker && !isInternal,
        },
        smallCompanyLogo: {
            src: companyImage,
        },
        messageAgeText: {
            variant: 'caption',
            clsMidGrayColor: true,
            value: createDtText,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const MessageBlock = props => {
    const content = _defaultTo(_get(props, 'content'), '');

    const getFormattedContent = useCallback(() => {
        const contentSplit = content.split('\n');
        return _map(contentSplit, (str, idx) => {
            const defn = {
                key: `inMessage-${idx}`,
                variant: 'body1',
                clsLightBold: false,
                value: str,
            };
            return <AfitdTypography {...defn} />;
        });
    }, [content]);

    const defns = getDefns({ props });

    return (
        <div {...defns.root}>
            <div {...defns.chatRightBlock2ProfileImageContainer}>
                <div {...defns.imageContainer}>
                    <Badge {...defns.smallCompanyLogoBadge} badgeContent={<AfitdAvatar {...defns.smallCompanyLogo} />}>
                        <AfitdAvatar {...defns.profileImage} />
                    </Badge>
                </div>
            </div>
            <div {...defns.chatRightBlock2MessageContainer}>
                <div {...defns.contentContainerIn}>{getFormattedContent(content)}</div>
                <div {...defns.attachmentContainer}>
                    <MessageFileBlock {...defns.attachment} />
                </div>
                <div>
                    <AfitdTypography {...defns.messageAgeText} />
                </div>
            </div>
        </div>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(MessageBlock);
